import React, { useEffect, useState } from 'react';
import FocusTrap from 'focus-trap-react';
import Helmet from 'react-helmet';
import {
  ModalBgContainer,
  ModalWindow,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalDivider,
  ArrowWhiteBtn,
  ArrowExternalBtn,
  LightBlueButton
} from './styles';

import welcomeModalCopy from '../../copy/welcome-modal';

const storageId = 'isHCP';

const WelcomeModal = () => {
  const [isHcp, setIsHcp] = useState(false);
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const storedValue = window.localStorage.getItem(storageId);
    if (storedValue !== null) {
      setIsHcp(storedValue === 'true');
    }
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); 
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isMobile !== true || isHcp) return;

    const normalOverlay = document.querySelector("[class^='styles__ModalBgContainer']");
    const cpraOverlay = document.querySelector("[class^='onetrust-pc-dark-filter']");

    if (normalOverlay) {
      normalOverlay.style.setProperty("background-color", "rgba(0, 0, 0, 0.7)", "important");
    }

    if (cpraOverlay) {
      cpraOverlay.style.setProperty("background", "none", "important");
    }
  }, [isMobile, isHcp]);

  useEffect(() => {
    if (!isMobile || !isHcp) return;

    const cpraOverlay = document.querySelector("[class^='onetrust-pc-dark-filter']");
    if (cpraOverlay) {
      cpraOverlay.style.setProperty("background-color", "rgba(0, 0, 0, 0.7)", "important");
      return;
    }

    const observer = new MutationObserver(() => {
      const overlay = document.querySelector("[class^='onetrust-pc-dark-filter']");
      if (overlay) {
        overlay.style.setProperty("background-color", "rgba(0, 0, 0, 0.7)", "important");
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [isMobile, isHcp]);

  const onPrimaryClick = () => {
    window.localStorage.setItem(storageId, 'true');
    setIsHcp(true);
  };

  return isHcp ? <></> : (
    <>
      <Helmet>
        <html lang="en-us" className="no-scroll" />
      </Helmet>

      <FocusTrap focusTrapOptions={{ initialFocus: false }}>
        <ModalBgContainer>
          <ModalWindow role="dialog" id="welcome-window" style={{ display: isHcp ? 'none' : 'block' }} aria-labelledby="welcome-dialog">
            <ModalContent>
              <ModalHeader id="welcome-dialog">{welcomeModalCopy.header}</ModalHeader>
              <LightBlueButton variant="primary" className="modal-button" onClick={onPrimaryClick}>
                {welcomeModalCopy.primaryCta}<ArrowWhiteBtn />
              </LightBlueButton>
              <ModalDivider />
              <LightBlueButton
                variant="primary"
                newWindow={false}
                to={welcomeModalCopy.secondaryCtaHref}
                className="modal-button"
              >
                {welcomeModalCopy.secondaryCta}<ArrowExternalBtn />
              </LightBlueButton>
              <ModalBody>{welcomeModalCopy.body}</ModalBody>
            </ModalContent>
          </ModalWindow>
        </ModalBgContainer>
      </FocusTrap>
    </>
  );
};

export default WelcomeModal;
 